import { z } from 'zod';

/** Optional display hints carried by the validation JSON scalar. */
export const validationFieldHighlightsSchema = z.object({
  highlightFieldMappingKeys: z.array(z.string().min(1)).min(1).optional(),
  canFilterHoverFields: z
    .unknown()
    .transform((value) => value === true)
    .optional(),
});

export type ValidationFieldHighlights = z.infer<
  typeof validationFieldHighlightsSchema
>;

/** Identifies the radio choice groups rendered as a single hover question. */
export function getValidationRadioGroupKey(
  fieldKey: string
): string | undefined {
  return fieldKey.match(/^(radio\[[^\]]+\])\[[^\]]+\]$/)?.[1];
}
